import React from "react";
import { message, Tabs, DatePicker, Row, Col, Pagination } from 'antd';
import "./DeliveredOrder.css";
import TableWidget from "./TableWidget/TableWidget";
import { TitleSearch } from "components/SearchWidget/TitleSearch";
import { useState } from "react";
import { useEffect } from "react";
import { apiGetOrderListDelivered, apiPaymentConfirmOrder } from "services/orderService";
const { RangePicker } = DatePicker;
function DeliveredOrder(props) {
    const { ownCommonData, setOwnCommonData, setIsBusy} = props;
    const [searchList, setSearchList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    useEffect(() => {
        setIsBusy(true)
        apiGetOrderListDelivered(currentPage, pageSize, startDate, endDate)
            .then((data) => {
                setIsBusy(false)
                setOwnCommonData({ ...ownCommonData, deliveredOrderList: data.deliveredOrderList })
                setTotalCount(data.total_count)
            })
            .catch((err) => {
                setIsBusy(false)
                message.error("Sorry! " + err);
            });
    }, [pageSize, currentPage, startDate, endDate]);

    useEffect(() => {
        if (ownCommonData.deliveredOrderList !== undefined) {
            setSearchList(ownCommonData.deliveredOrderList)
        }
    }, [ownCommonData]);

    const onShowSizeChange: PaginationProps['onShowSizeChange'] = (current, pageSize) => {
        setPageSize(pageSize);
        setCurrentPage(current);
    };
    const onChange: PaginationProps['onChange'] = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleSearch = (searchText) => {
        const tmpList = ownCommonData.deliveredOrderList.filter((info) => info.customer_name.toLowerCase().includes(searchText))
        setSearchList([...tmpList])
    };
    const handleChange = (event) => {
        if (event.target.value === "") {
            setSearchList(ownCommonData.deliveredOrderList)
        }
        else {
            handleSearch(event.target.value)
        }
    };
    const paymentConfirmAction = async(record) => {
        
        setIsBusy(true);
        apiPaymentConfirmOrder(record)
            .then((data) => {
                setIsBusy(false)
                message.success("Payment Confirm Success")
                record.payment_status = 'Completed';
                ownCommonData.deliveredOrderList.splice(ownCommonData.deliveredOrderList.findIndex(e => e.id === record.id),1);
                let deliveredOrderList = ownCommonData.deliveredOrderList.concat(record)
                setOwnCommonData({...ownCommonData, deliveredOrderList: deliveredOrderList})
                setSearchList(ownCommonData.deliveredOrderList)

            })
            .catch((err) => {
                setIsBusy(false);
                message.error("Payment Confirm Error. " + err);
            });
    }
    const handleDateFilter = (startDate, endDate) => {
        setCurrentPage(1)
        setStartDate(startDate)
        setEndDate(endDate)

    }
    return (
        <div>
            <Row>
                <Col>
                    <div style={{ fontFamily: 'mediumFont', padding: 20 }}>Date Filter Period : &nbsp;&nbsp;
                        <RangePicker size={'default'}
                            onChange={(e, date) => {
                                if (date == null) {
                                    handleDateFilter("", "")
                                } else {
                                    handleDateFilter(date[0], date[1])
                                }

                            }} />
                    </div>
                </Col>
                <Col flex={'auto'}>
                    <div style={{ fontFamily: 'mediumFont', padding: 20 }}>
                        <TitleSearch
                            onSearch={handleSearch}
                            onChange={handleChange}
                            onPressEnter={handleSearch}
                        />
                    </div>
                </Col>
            </Row>
            <Row justify={"center"} style={{paddingTop:16}}>
                <Col>
                    <Pagination
                        showSizeChanger
                        onShowSizeChange={onShowSizeChange}
                        onChange={onChange}
                        defaultCurrent={1}
                        current={currentPage}
                        total={totalCount}
                        pageSize={pageSize}
                    />
                </Col>
            </Row>
            <div>
                <TableWidget
                    dataList={searchList}
                    setDataList={setSearchList}
                    paymentConfirmAction={paymentConfirmAction}
                />
            </div>
        </div>
    );
}

export default DeliveredOrder;
